export default {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  userPoolDomain: import.meta.env.VITE_COGNITO_USER_POOL_DOMAIN,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  callbackSignIn: import.meta.env.VITE_COGNITO_CALLBACK_SIGN_IN,
  callbackSignOut: import.meta.env.VITE_COGNITO_CALLBACK_SIGN_OUT,
};
